<div
  [formGroup]="group"
  [ngClass]="attribute.elementStyles.containerStyle"
  [attr.data-test-id]="'wrap-' + attribute.elementDataTestId"
>
  <label class="form-label" *ngIf="isNotPhoto()" [ngClass]="attribute.elementStyles.labelStyle">
    {{ attribute.backendAttribute.label | translate }}
    <span *ngIf="attribute.backendAttribute.required">*</span>
  </label>
  <div [ngClass]="inputContainerStyle">
    <input
      [class.is-invalid]="valid"
      [ngClass]="attribute.elementStyles.contentStyle"
      type="file"
      [id]="attribute.backendAttribute.name"
      [attr.data-test-id]="attribute.elementDataTestId"
      [accept]="acceptedFilesExtensions"
      [multiple]="attribute.multiple"
      (change)="onFileChanged($event)"
    />
    <label
      *ngIf="isNotPhoto()"
      class="form-label custom-file-label text-truncate"
      [class.file-label]="!!fileName"
      [for]="attribute.backendAttribute.name"
      [attr.data-test-id]="attribute.elementDataTestId + '-label'"
    >
      {{ fileName ? fileName : (attribute.backendAttribute.placeholder | translate) }}
    </label>
  </div>
</div>
